import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import logo from "../assets/images/asset-planet-background.png";
// import userProfile from "../assets/images/users/user-1.jpg";
import defaultProfilePicture from "../assets/images/newdefaultprofilepicture.png";
import Loader from "./styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import { MODULE_API } from "../apis";
import { sideItemsProfile } from "./SidebarConstants";
import SidebarMenu from "./SidebarMenu";
import SidebarSubMenu from "./SidebarSubMenu";
import dashboard1 from "../assets/images/Sidebar_Icons/ZLOGOUT.png";
import { resetStateProperties } from "../redux/slices/propertiesSlice";
import { resetStateRooms } from "../redux/slices/roomsSlice";
import { resetStateItems } from "../redux/slices/itemsSlice";
import axios from "axios";
import { useTheme } from "../utils/ThemeContext";
import { resetStateChat,setUnseenMessages,setUnReadCount } from "../redux/slices/chatSlice";
import { closeWebsocket } from "../utils/websocketConnect";

const SidebarProfile = (props) => {
  const { setTheme } = useTheme();

  const [isMenuOpened, setisMenuOpened] = useState(true);
  const [accessId, setAccessId] = useState("");
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );
  const [defaultValueName, setDefaultValueName] = useState("Me");
  const [userRoles, setUserRoles] = useState("");
  const [userss, setUserss] = useState("");
  const [active, setActive] = useState();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [formDataProfile, setFormDataProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);

  const handleImageUpload = async (event) => {
    // event.preventDefault();

    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      setLoading(false);
      setFormDataProfile({
        ...formDataProfile,
        ["image"]: res,
      });
      let obj = {
        ...formDataProfile,
        ["image"]: res,
      };
      handleSubmit(obj);
    }
  };

  const handleSubmit = async (obj) => {
    try {
      setLoading(true);
      await DEATH_API.updateProfileData(obj);
      setLoading(false);
      setFormDataProfile(null);
      setChange(!change);
      getProfileDetails();
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      //   setFormData(null);
      setLoading(true);
      let data = await DEATH_API.getProfileData();
      if (data && data.data) {
        data.data.phoneNumber = `${data.data.countryCode} ${data.data.phoneNumber}`;
        if (data.data.image) {
          localStorage.setItem("profile", data.data.image);
        }
        if (data.data.name) {
          localStorage.setItem("User", data.data.name);
        }
        setFormDataProfile(data.data);
        props.profileState(!props.profileChange);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const excludedPaths = ["/otpvalidation"];
  useEffect(() => {
    let userRole1 = "";
    let users1 = "";
    if (!excludedPaths.includes(location.pathname)) {
      getProfileDetails();
    }
    try {
      userRole1 =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role") || null);
      users1 =
        localStorage.getItem("delegateUsers") != "undefined" &&
        JSON.parse(localStorage.getItem("delegateUsers") || null);
      setUserRoles(userRole1);
      setUserss(users1);
      if (localStorage.getItem("accessId")) {
        const defaultValue =
          users1 &&
          users1.filter((item) => item.id == localStorage.getItem("accessId"));
        setDefaultValueName(defaultValue[0].userName);
      } else {
        setDefaultValueName("Me");
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [activated, accessId]);

  const toggleMenu = (e) => {
    e.preventDefault();
    setisMenuOpened(!isMenuOpened);
  };
  const signOut = (e) => {
    // e.preventDefault();
    setTheme("light");
    dispatch(resetStateProperties());
    dispatch(resetStateRooms());
    dispatch(resetStateItems());
    dispatch(resetStateChat());
    dispatch(setUnReadCount(0));
    dispatch(setUnseenMessages([]));
    closeWebsocket();

    localStorage.removeItem("userLoginToken");
    localStorage.removeItem("role");
    localStorage.removeItem("delegateUsers");
    localStorage.removeItem("otp");
    localStorage.removeItem("User");
    localStorage.removeItem("fields");
    localStorage.removeItem("accessId");
    localStorage.removeItem("duplicateRole");
    localStorage.removeItem("profile");
    localStorage.removeItem("permissionState");
    localStorage.removeItem("userName");
    localStorage.clear();
  };

  return (
    <div className="left-side-menu" style={{ background: "white" }}>
      <div
        style={{
          height: "70px",
          display: "flex",
          alignItems: "center",
        }}>
        <span className="left-side-collapse-icon-custom">
          <img
            src={logo}
            className="bg-logo"
            style={{ width: "85%", height: "32.4px" }}
          />
        </span>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "2rem",
          }}>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleImageUpload}
            accept="image/*"
            style={{ display: "none" }}
          />
          <label htmlFor="image" style={{ cursor: "pointer" }}>
            {/* <img
              width={128}
              height={128}
              style={{
                borderRadius: "50%",
                border: "2px solid #ED2590",
                padding: "4px",
              }}
              src={
                (localStorage.getItem("profile") &&
                  localStorage.getItem("profile")) ||
                defaultProfilePicture
              }
              alt="defaultProfilePicture"
            /> */}
            <div
              style={{
                width: "128px",
                minHeight: "128px",
                borderRadius: "50%",
                border: "2px solid #ED2590",
                padding: "4px",
                backgroundImage: `url('${
                  (localStorage.getItem("profile") &&
                    localStorage.getItem("profile")) ||
                  defaultProfilePicture
                }')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}></div>
          </label>
          <span style={{ fontWeight: "bold", marginTop: "2rem" }}>
            {localStorage.getItem("User") ? (
              localStorage.getItem("User")
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </span>
          {/* <span style={{ marginTop: "8px" }}>Project Manager</span> */}
        </div>
      </div>
      <div id="sidebar-menu" className="active">
        <ul
          className="metismenu in nav"
          id="nav"
          style={{ marginTop: "21rem" }}>
          {/*       <li>
        {userRoles && userss && userss.length > 0 && (
          <Link to="/delgateAccess" className="">
            <div
              className={
                location.pathname == "/delgateAccess"
                  ? `side-menu-block1-active`
                  : `side-menu-block1`
              }>
              <div>
                <img
                  src={
                    location.pathname == "/delgateAccess"
                      ? dashboard2
                      : dashboard1
                  }
                  className="img-icon"
                />
                <span style={{ paddingLeft: "10px" }} className="">
                  Delegate Access
                </span>
              </div>
            </div>
          </Link>
        )}
                </li> */}
          {sideItemsProfile.map((item, index) => (
            <li
              key={index}
              style={{
                display: item.title === "Setting" ? "none" : "flex",
                flexDirection: "row",
                // opacity: "",
              }}>
              <SidebarMenu item={item} />
              {item.subNav && (
                <ul style={{ padding: "10px" }}>
                  {item.subNav.map((item, index) => (
                    <li key={index} style={{}}>
                      <SidebarSubMenu item={item} />
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <li className="hover-logout-icon-profile-sidebar">
            <Link onClick={signOut} to="/login">
              <div className="side-menu-block1 hoverIconLogout">
                <div className="">
                  <img src={dashboard1} className="img-icon " />
                  <span style={{ paddingLeft: "10px" }} className="">
                    Logout
                  </span>
                </div>
              </div>
            </Link>
          </li>
        </ul>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};

export default SidebarProfile;
